var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"confirmation",class:{ error: _vm.isError }},[_vm._v(" "+_vm._s(_vm.isError ? '認証失敗' : '認証中・・・')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }